import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MemberAccount } from '../../../../../models/transactions/member-account';

@Component({
  selector: 'app-affected-account',
  templateUrl: './affected-account.component.html',
  styleUrls: ['./affected-account.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AffectedAccountComponent {
  @Input() account: MemberAccount = new MemberAccount();
  @Input() lastInList: boolean = false;
}
